export const HOTEL_SYSTEMS = 'hotel_systems';
export const INTEGRATIONS = `integrations`;
export const DESIGN_CONFIGS = `design_configs`;

export const HOTEL_SERVICES = 'hotelServiceModules';
export const GUEST_ROOM_EXP = 'guestRoomExpModules';
export const ENTERTAINMENT = 'entertainmentModules';

export const HOTEL_SYSTEMS_TITLES = {
  hotelServiceModules: 'Hotel Services',
  guestRoomExpModules: 'Guest Room Experience',
  entertainmentModules: 'Entertainment',
};

export const DEVICE_NAMES = {
  webApp: 'Web app',
  mobile: 'Mobile app',
  tablet: 'Tablet',
};

export const hotelServiceModules = [
  {
    key: 'DIGITAL_CHECK_IN',
    value: 'Digital Check-In',
  },
  {
    key: 'TABLE_RESERVATIONS',
    value: 'Table Reservations',
  },
  {
    key: 'SERVICE_REQUEST',
    value: 'Service Request',
  },
  {
    key: 'FEEDBACK',
    value: 'Feedback',
  },
  {
    key: 'DIGITAL_MENU_FOR_F_AND_B_OUTLETS',
    value: 'Digital Menu for F&B Outlets',
  },
  {
    key: 'OFFERS_AND_PROMOTIONS',
    value: 'Offers & Promotions',
  },
  {
    key: 'CHAT_PLATFORM',
    value: 'Chat Platform',
  },
  {
    key: 'IN_ROOM_DINING',
    value: 'In-Room Dining',
  },
  {
    key: 'HOTEL_COMPENDIUM',
    value: 'Hotel Compendium',
  },
  {
    key: 'VIEW_BILL',
    value: 'View Bill',
  },
  {
    key: 'SPA_RESERVATIONS',
    value: 'Spa Reservations',
  },
  {
    key: 'LOYALTY_INTEGRATIONS',
    value: 'Loyalty Integrations',
  },
  {
    key: 'EXPRESS_CHECK_OUT',
    value: 'Express Check-out',
  },
  {
    key: 'ROOM_RESERVATIONS',
    value: 'Room Reservations',
  },
];

export const guestRoomExpModules = [
  {
    key: 'LIGHT_CONTROLS',
    value: 'Light Controls',
  },
  {
    key: 'ALEXA_VOICE_CONTROLS',
    value: 'Alexa Voice Controls',
  },
  {
    key: 'THERMOSTAT_CONTROL',
    value: 'Thermostat Control',
  },
  {
    key: 'CHROME_CAST',
    value: 'Chrome Cast',
  },
  {
    key: 'DIGITAL_MOBILE_KEY',
    value: 'Digital Mobile Key',
  },
  {
    key: 'CURTAIN_CONTROLS',
    value: 'Curtain Controls',
  },
  {
    key: 'MINI_BAR_MENU',
    value: 'Mini Bar Menu',
  },
  {
    key: 'SOFT_PHONE_EXTENSION',
    value: 'Soft Phone Extension',
  },
  {
    key: 'TV_CONTROLS',
    value: 'TV Controls',
  },
  {
    key: 'DOOR_CAMERA',
    value: 'Door Camera',
  },
];

export const entertainmentModules = [
  {
    key: 'IPTV',
    value: 'IPTV',
  },
  {
    key: 'CASTING',
    value: 'Casting',
  },
  {
    key: 'APPLE_TV_WITH_MEDIA_CONTROLS',
    value: 'Apple TV App with Media Controls',
  },
];

export const curtainType = [
  {
    name: 'Sheers',
    id: 'SHEERS',
  },
  {
    name: 'Blinds',
    id: 'BLINDS',
  },
  {
    name: 'Curtains',
    id: 'CURTAINS',
  },
];

export const lightType = [
  {
    name: 'ON/OFF',
    id: 'ON_OFF',
  },
  {
    name: 'Dimmer',
    id: 'DIMMER',
  },
];

export const lightIcons = [
  {
    id: 'BED',
    name: 'Bed',
    url: '/assets/icons/configurations/bed.svg',
  },
  {
    id: 'KITCHEN',
    name: 'Kitchen',
    url: '/assets/icons/configurations/kitchen.svg',
  },
  {
    id: 'COUCH',
    name: 'Couch',
    url: '/assets/icons/configurations/couch.svg',
  },
  {
    id: 'OPEN_DOOR',
    name: 'Open Door',
    url: '/assets/icons/configurations/opendoor.svg',
  },
  {
    id: 'CAMERA_OUTDOOR',
    name: 'Camera Outdoor',
    url: '/assets/icons/configurations/cameraoutdoor.svg',
  },
  {
    id: 'FLOURESCENT',
    name: 'Flourescent',
    url: '/assets/icons/configurations/flourescent.svg',
  },
  {
    id: 'LIGHT1',
    name: 'Light1',
    url: '/assets/icons/configurations/light1.svg',
  },
  {
    id: 'COUNTER_TOP',
    name: 'Counter Top',
    url: '/assets/icons/configurations/countertop.svg',
  },
  {
    id: 'BATHTUB',
    name: 'Bath Tub',
    url: '/assets/icons/configurations/bathtub.svg',
  },
  {
    id: 'DECK',
    name: 'Deck',
    url: '/assets/icons/configurations/deck.svg',
  },
  {
    id: 'SHOWER',
    name: 'Shower',
    url: '/assets/icons/configurations/shower.svg',
  },
  {
    id: 'SPOTLIGHT',
    name: 'Spotlight',
    url: '/assets/icons/configurations/spotlight.svg',
  },
  {
    id: 'CHANDELIER',
    name: 'Chandelier',
    url: '/assets/icons/configurations/chandelier.svg',
  },
  {
    id: 'LAMP',
    name: 'Lamp',
    url: '/assets/icons/configurations/lamp.svg',
  },
  {
    id: 'MIRROR',
    name: 'Mirror',
    url: '/assets/icons/configurations/mirror.svg',
  },
];
